//  mutaciones son sincronas y hacen modificaciones del state
export const setUser = (state, update) => {
  const { data = null } = update
  if(data) {
    const { token = null } = data
    if(token) {
      localStorage.setItem('session_id', token);
      state.token = token;
    }
  }
}

export const setLogout = (state) => {
  localStorage.clear();
  state.token = null;
}

// Catalogo Carreras
export const setCarreras = (state, carreras) => {
  if(carreras.length !== 0){
    state.itemCarreras = [...carreras];
  }  
}

// Catalogo Estancia
export const setEstancias = (state, estancias) => {
  if(estancias.length !== 0){
    state.itemEstancias = [...estancias];
  }  
}

// Alert mutations
export const setAlert = (state, value) => {
  state.showAlert = value
}

export const setDataAlert = (state, value) => {
  state.dataAlert = value
}